import React from "react";
import { Mui } from "@osu/react-ui";
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";

function SplashPage() {
    const authInfo = useRoleAuthentication();
    if (authInfo.isLoggedIn) { return; }

    return <Mui.Skeleton sx={{ height: "3.1337rem" }} title="Loading login information or redirecting to login page, please wait" />;
}

export default SplashPage;